module.exports = __webpack_public_path__ + "img/changjing3.32aea60c.png";